<app-header style="width: 100%"></app-header>
<section
    class="sme-new-app tw-pb-[45px] tw-bg-gradient-to-b tw-from-[#FFFBF8] tw-to-[40%] tw-to-[#F9F9F9]"
>
    <div class="sme-container">
        <app-application-stepper [value]="value" [productName]="productName"></app-application-stepper>
        <mat-divider></mat-divider>
        <!--DESKTOP-->
        <div
            class="tw-flex tw-flex-col tw-items-start tw-gap-[10px] xl:tw-mx-0 md:tw-px-[75px]"
        >
            <div class="tw-hidden xl:tw-flex tw-flex-col tw-gap-[10px]">
                <span
                    class="tw-font-bold tw-text-[#7B7575] tw-text-lg"
                    *ngIf="productName"
                >
                    {{ "PRODUCT_MATCHING.YOU_ARE_APPLYING_FOR" | translate }}:
                </span>
                <div
                    class="tw-bg-[#E3E8EC] tw-w-auto tw-text-center tw-p-[16px] tw-rounded-[16px]"
                    *ngIf="productName"
                >
                    <span
                        class="md:tw-text-2xl tw-font-semibold tw-text-[#003A70]"
                    >
                        {{ productName }}
                    </span>
                </div>
            </div>
        </div>
        <!--DESKTOP-->
        <!--MOBILE-->
        <div
            class="tw-flex xl:tw-hidden tw-grid tw-items-center tw-grid-cols-1 xl:tw-grid-cols-[calc(100%_-_310px),300px] tw-gap-[10px] tw-pt-[40px] tw-pb-[20px] md:tw-pt-[10px] md:tw-pb-[10px] tw-mx-0 md:tw-mx-[80px] xl:tw-mx-0"
        >
            <div class="tw-flex tw-flex-col tw-gap-[12px]">
                <mat-card
                    class="cardCSS"
                    appearance="outlined"
                    *ngIf="productName"
                >
                    <mat-card-content>
                        <div class="tw-flex tw-flex-col tw-gap-[15px]">
                            <div
                                class="tw-font-[500] tw-text-[#6B6B6B] tw-text-[16px] tw-text-center"
                            >
                                {{
                                    "NEW_APPLICATION.YOU_ARE_APPLYING_FOR"
                                        | translate
                                }}
                            </div>
                            <div
                                class="tw-bg-[#E3E8EC] tw-p-[16px] tw-rounded-[16px] tw-text-center"
                            >
                                <span
                                    class="tw-text-[14px] tw-leading-[16.8px] tw-font-[700] tw-text-[#003A70]"
                                >
                                    {{ productName }}
                                </span>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
                <ngx-slick-carousel
                    class="carousel"
                    #slickModal="slick-carousel"
                    [config]="slideConfig"
                    (afterChange)="afterChange($event)"
                    (beforeChange)="beforeChange($event)"
                >
                    <div
                        ngxSlickItem
                        *ngFor="let i of rightSide; let index = index"
                    >
                        <div
                            class="tw-relative tw-w-full tw-h-auto tw-overflow-hidden tw-rounded-lg md:tw-rounded-2xl"
                        >
                            <mat-card class="cardCSS" appearance="outlined">
                                <mat-card-content>
                                    <div
                                        class="tw-flex tw-flex-col tw-gap-[10px]"
                                    >
                                        <div
                                            class="tw-flex tw-flex-row tw-gap-[14px]"
                                        >
                                            <img
                                                *ngIf="index == 0"
                                                class="tw-w-[45px] tw-h-[45px]"
                                                src="/assets/images/preliminary.png"
                                                alt="preliminary"
                                            />
                                            <img
                                                *ngIf="index == 1"
                                                class="tw-w-[45px] tw-h-[45px]"
                                                src="/assets/images/expand_circle_right.png"
                                                alt="expand_circle_right"
                                            />
                                            <img
                                                *ngIf="index == 2"
                                                class="tw-w-[45px] tw-h-[45px]"
                                                src="/assets/images/done.png"
                                                alt="done"
                                            />
                                            <div
                                                class="tw-font-semibold tw-leadng-[21.6px] tw-text-[18px] tw-m-auto"
                                            >
                                                {{ i.title | translate }}
                                            </div>
                                        </div>
                                        <mat-divider
                                            class="small"
                                        ></mat-divider>
                                        <div
                                            class="tw-font-medium tw-leading-[24px] tw-text-[16px] tw-mb-[14px]"
                                        >
                                            {{ i.subtitle | translate }}
                                        </div>
                                    </div>
                                </mat-card-content>
                            </mat-card>
                        </div>
                    </div>
                </ngx-slick-carousel>
            </div>
        </div>
        <!--MOBILE-->

        <div class="tw-pt-0 md:tw-pt-[5%] tw-grid tw-grid-cols-1">
            <div class="tw-px-0 md:tw-px-[75px]">
                <h5
                    class="sme-new-app tw-pb-3 tw-border-b tw-border-solid tw-border-[#8D8D8D]/[0.25]"
                >
                    {{ "COMMON.FINANCING_DETAILS" | translate }}
                </h5>
                <div
                    class="tw-grid tw-gap-[15px] md:tw-grid-cols-[260px,200px,260px] tw-mb-[28px] md:tw-mb-[60px]"
                >
                    <div>
                        <span
                            class="tw-block tw-text-[16px] tw-leading-[24px] tw-text-caption-gray tw-font-[500] tw-mb-[4px] md:tw-mb-[8px]"
                            >{{
                                "NEW_APPLICATION.PREFERRED_AMOUNT" | translate
                            }}</span
                        >
                        <span
                            class="tw-block tw-text-black tw-text-[21px] md:tw-text-[24px] tw-leading-normal md:tw-leading-[32px] tw-font-[600]"
                            >RM{{ eligibilityDetails?.financingAmount }}</span
                        >
                    </div>
                    <div
                        class="tw-row-start-2 tw-row-end-[2.5] md:tw-row-start-[unset] md:tw-row-end-[unset]"
                    >
                        <span
                            class="tw-block tw-text-[16px] tw-leading-[24px] tw-text-caption-gray tw-font-[500] tw-mb-[4px] md:tw-mb-[8px]"
                            >{{
                                "NEW_APPLICATION.ELIGIBILITY_TENURE" | translate
                            }}</span
                        >
                        <span
                            *ngIf="!isDGP"
                            class="tw-block tw-text-black tw-text-[21px] md:tw-text-[24px] tw-leading-normal md:tw-leading-[32px] tw-font-[600]"
                            >{{ eligibilityDetails?.tenureYears }}
                            {{
                                "NEW_APPLICATION.ELIGIBILITY_TENURE_YEARS"
                                    | translate
                            }}</span
                        >
                        <span
                            *ngIf="isDGP"
                            class="tw-block tw-text-black tw-text-[21px] md:tw-text-[24px] tw-leading-normal md:tw-leading-[32px] tw-font-[600]"
                            >{{ prodvalidation?.tenure?.min }} -
                            {{ prodvalidation?.tenure?.max }}
                            {{
                                prodvalidation?.tenure?.unit
                                    | uppercase
                                    | translate
                            }}</span
                        >
                    </div>
                    <div
                        class="tw-row-start-[2.5] tw-row-end-[3] md:tw-row-start-[unset] md:tw-row-end-[unset]"
                    >
                        <span
                            class="tw-block tw-text-[16px] tw-leading-[24px] tw-text-caption-gray tw-font-[500] tw-mb-[4px] md:tw-mb-[8px]"
                            >{{
                                "NEW_APPLICATION.ELIGIBILITY_INTEREST"
                                    | translate
                            }}</span
                        >
                        <span
                            class="tw-block tw-text-black tw-text-[21px] md:tw-text-[24px] tw-leading-normal md:tw-leading-[32px] tw-font-[600]"
                            >{{
                                eligibilityDetails.prodSelectionList
                                    .prodNameList[0].prodAvgIr
                            }}%</span
                        >
                    </div>
                </div>
                <div
                    class="tw-pb-[17px] tw-mb-[18px] tw-border-b tw-border-solid tw-border-[#8D8D8D]/[0.25]"
                >
                    <h5 class="!tw-mb-0"></h5>
                </div>
                <div
                    *ngIf="
                        eligibilityDetails.prodSelectionList.branchActive ==
                            'N' ||
                        !(
                            this.eligibilityDetails?.prodSelectionList
                                ?.branchListing?.length > 0
                        )
                    "
                    class="tw-rounded-[16px] tw-mb-[8px] md:tw-mb-[63px] tw-px-[23px] md:tw-px-[32px] tw-py-[14px] md:tw-py-[18px] tw-bg-[#E1EFF7] tw-border-[1.5px] tw-border-solid tw-border-[#4B6EEC]"
                >
                    <h5 class="!tw-mb-0">
                        {{
                            eligibilityDetails.prodSelectionList.prodNameList[0]
                                .productName
                        }}
                    </h5>
                </div>
                <div
                    *ngIf="
                        eligibilityDetails.prodSelectionList.branchActive ==
                            'Y' &&
                        this.eligibilityDetails?.prodSelectionList
                            ?.branchListing?.length > 0
                    "
                >
                    <mat-expansion-panel disabled [expanded]="true" hideToggle>
                        <mat-expansion-panel-header
                            (click)="isToggleOpen = !isToggleOpen"
                            class="tw-cursor-default"
                        >
                            <mat-panel-title>
                                <h5 class="!tw-mb-0 tw-text-black">
                                    <!-- {{
                                        eligibilityDetails.prodSelectionList
                                            .prodNameList[0].productName
                                    }} -->
                                    {{
                                        eligibilityDetails.prodSelectionList
                                            .fiNameEN
                                    }}
                                </h5>
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                        <div>
                            <div
                                class="tw-bg-white md:tw-px-11 tw-py-8 tw-rounded-3xl"
                            >
                                <div
                                    class="tw-px-5 md:tw-px-0 tw-font-bold tw-text-lg tw-text-[#003A70]"
                                >
                                    {{
                                        eligibilityDetails.prodSelectionList
                                            .prodNameList[0].productName
                                    }}
                                </div>
                                <div
                                    class="tw-px-5 md:tw-px-0 tw-pb-7 tw-text-base tw-font-medium tw-text-caption-gray"
                                >
                                    {{
                                        "NEW_APPLICATION.CGC_PRODUCT_BRANCH_SELECTION"
                                            | translate
                                    }}
                                </div>

                                <section
                                    class="tw-flex tw-flex-col md:tw-w-auto md:tw-h-[550px] tw-h-[850px] tw-p-6 tw-w-full"
                                >
                                    <div
                                        class="tw-flex tw-justify-around tw-flex-col md:tw-flex-row tw-items-start"
                                    >
                                        <div
                                            class="tw-flex tw-flex-col tw-gap-[2px]"
                                        >
                                            <div
                                                class="tw-text-[#003A70] tw-font-bold tw-text-lg"
                                            >
                                                <div
                                                    *ngIf="
                                                        selectedBranchName;
                                                        else noBranchSelected
                                                    "
                                                >
                                                    {{ selectedBranchName }}
                                                </div>
                                                <ng-template #noBranchSelected>
                                                    {{
                                                        "SELECT_BRANCH.SELECT_A_BRANCH"
                                                            | translate
                                                    }}
                                                </ng-template>
                                            </div>
                                            <div
                                                class="tw-text-[#6D7A87] tw-font-semibold"
                                            >
                                                {{
                                                    "SELECT_BRANCH.ONLY_ONE_BRANCH_IS_TO_BE_SELECTED"
                                                        | translate
                                                }}
                                            </div>
                                        </div>
                                        <div
                                            class="tw-content-center tw-relative tw-gap-2 tw-rounded-xl tw-h-[49.5px] tw-w-full tw-mt-5 md:tw-w-auto md:tw-mt-0"
                                            [ngClass]="{
                                                'tw-bg-[rgba(198,204,214,0.15)]':
                                                    !searchInput,
                                                'tw-border tw-bg-white':
                                                    searchInput
                                            }"
                                        >
                                            <div
                                                class="tw-px-3 tw-flex tw-items-center tw-gap-2"
                                            >
                                                <img
                                                    src="../../../../../../assets/images/Search.svg"
                                                    alt="Search"
                                                    *ngIf="!searchInput"
                                                    height="21px"
                                                    width="21px"
                                                />
                                                <input
                                                    class="tw-flex-1 tw-bg-transparent tw-font-bold tw-text-[16px] tw-text-[#003A70]"
                                                    placeholder="{{
                                                        'SELECT_BRANCH.CITY'
                                                            | translate
                                                    }}, {{
                                                        'SELECT_BRANCH.POST_CODE'
                                                            | translate
                                                    }}"
                                                    [(ngModel)]="searchInput"
                                                    (keyup)="
                                                        onSearchBranch(
                                                            searchInput
                                                        )
                                                    "
                                                />
                                                <img
                                                    src="../../../../../../assets/images/Location.svg"
                                                    alt="Location"
                                                    *ngIf="!searchInput"
                                                    height="21px"
                                                    width="21px"
                                                />
                                                <div
                                                    *ngIf="searchInput"
                                                    class="tw-flex tw-bg-[rgba(198,204,214,0.15)] tw-p-1 tw-rounded-full tw-cursor-pointer"
                                                >
                                                    <img
                                                        src="../../../../../../assets/images/Close.svg"
                                                        alt="Close"
                                                        (click)="
                                                            clearSearchInput()
                                                        "
                                                        height="15px"
                                                        width="16px"
                                                    />
                                                </div>
                                            </div>
                                            <div
                                                id="branchSuggestion"
                                                *ngIf="
                                                    searchInput &&
                                                    branchSuggestion &&
                                                    branchSuggestion.length
                                                "
                                                class="tw-absolute tw-w-full md:tw-w-[493px] tw-top-full tw-mt-2 tw-flex-shrink-0 tw-rounded-[16px] tw-p-[16px] tw-border tw-border-[rgba(216,216,216,0.5)] tw-bg-white tw-shadow-[2px_4px_16px_0px_rgba(163,148,131,0.04)]"
                                                style="
                                                    max-height: 203px;
                                                    overflow-y: auto;
                                                    scrollbar-width: none;
                                                "
                                            >
                                                <div
                                                    *ngFor="
                                                        let branch of branchSuggestion
                                                    "
                                                    class="tw-cursor-pointer tw-p-1 tw-hover:bg-gray-100"
                                                >
                                                    <div
                                                        class="tw-flex"
                                                        (click)="
                                                            selectAutoSuggestion(
                                                                branch
                                                            )
                                                        "
                                                    >
                                                        <img
                                                            src="../../../../../../assets/images/Arrow.svg"
                                                            alt="Arrow"
                                                        />
                                                        <div
                                                            class="tw-font-figtree tw-text-lg tw-font-semibold tw-leading-[40px] tw-pl-5 tw-text-[rgba(109,122,135,0.70)]"
                                                            [innerHTML]="
                                                                highlightText(
                                                                    branch.ptc +
                                                                        ' ' +
                                                                        branch.city,
                                                                    searchInput
                                                                )
                                                            "
                                                        ></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <button
                                            (click)="toggleDropdown($event)"
                                            class="tw-flex tw-items-center tw-gap-2 tw-border tw-rounded-xl tw-px-3 tw-h-[49.5px] tw-w-full md:tw-w-[30%] tw-mt-5 md:tw-mt-0 tw-bg-[#FBFBFB]"
                                        >
                                            <div
                                                class="tw-flex-1 tw-flex tw-bg-transparent tw-font-bold tw-text-lg tw-text-[#003A70]"
                                            >
                                                {{ selectedState || "State" }}
                                            </div>
                                            <div class="">
                                                <img
                                                    [ngClass]="{
                                                        'tw-rotate-180':
                                                            isStateDropdownOpen
                                                    }"
                                                    src="../../../../../../assets/images/Arrow_Down.svg"
                                                    alt="Arrow_Down"
                                                    width="11"
                                                    height="6"
                                                />
                                            </div>
                                        </button>

                                        <div
                                            id="stateDropdown"
                                            *ngIf="isStateDropdownOpen"
                                            class="tw-absolute tw-z-10 tw-overflow-hidden tw-right-0 md:tw-mr-[6.2rem] tw-mr-[1.6rem] tw-mt-[26rem] md:tw-mt-14 md:tw-w-[17.5rem] tw-w-[20.4rem] tw-origin-top-right tw-divide-y tw-divide-gray-100 tw-rounded-2xl tw-bg-white tw-shadow-lg tw-ring-1 tw-ring-black tw-ring-opacity-5"
                                            role="menu"
                                            aria-orientation="vertical"
                                            aria-labelledby="menu-button"
                                            tabindex="-1"
                                        >
                                            <div
                                                class="tw-max-h-[225px] tw-overflow-y-auto"
                                                style="scrollbar-width: thin"
                                            >
                                                <button
                                                    class="tw-px-4 tw-py-4 tw-text-base tw-w-full tw-text-left tw-font-semibold tw-opacity-50"
                                                    (click)="resetState()"
                                                    disabled
                                                >
                                                    State
                                                </button>
                                                <div class="tw-px-4">
                                                    <hr />
                                                </div>
                                                <ng-container
                                                    *ngFor="
                                                        let state of stateOptions
                                                    "
                                                >
                                                    <button
                                                        class="tw-px-4 tw-py-4 tw-text-base tw-w-full tw-text-left tw-font-semibold {{
                                                            selectedState ===
                                                            state
                                                                ? 'tw-bg-[#4B6EEC] tw-text-white'
                                                                : ''
                                                        }}"
                                                        (click)="
                                                            selectState(state)
                                                        "
                                                    >
                                                        {{ state }}
                                                    </button>
                                                    <div class="tw-px-4">
                                                        <hr />
                                                    </div>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="tw-h-[1px] tw-bg-[#8d8d8d48] tw-my-5"
                                    ></div>
                                    <ng-container
                                        *ngIf="
                                            branches?.length > 0;
                                            else noSearchResult
                                        "
                                    >
                                        <div
                                            class="tw-flex tw-flex-1 tw-flex-col tw-my-6 tw-gap-4 tw-h-[800px] md:tw-h-[500px] tw-overflow-y-scroll md:tw-mr-8 md:tw-pr-2"
                                        >
                                            <div
                                                *ngFor="
                                                    let item of branches;
                                                    let i = index
                                                "
                                                class="tw-flex tw-gap-4 tw-items-center tw-p-4 tw-rounded-xl"
                                                [ngClass]="
                                                    selectedBranchIndex == i &&
                                                    'tw-bg-[#003a702d]'
                                                "
                                            >
                                                <input
                                                    class="tw-cursor-pointer"
                                                    type="radio"
                                                    name="action"
                                                    value="{{ i }}"
                                                    (click)="
                                                        onSelectBranch(
                                                            i,
                                                            item.branchName
                                                        )
                                                    "
                                                    [checked]="
                                                        selectedBranchIndex == i
                                                    "
                                                />
                                                <div
                                                    class="tw-flex tw-flex-col tw-gap-2 tw-flex-1"
                                                >
                                                    <div
                                                        class="tw-font-bold tw-text-lg tw-text-[#003A70]"
                                                    >
                                                        {{ item.branchName }},
                                                        {{ item.city }}
                                                    </div>
                                                    <div
                                                        class="tw-font-semibold tw-text-[#6D7A87]"
                                                    >
                                                        {{ item.description }}
                                                    </div>
                                                    <div
                                                        class="tw-flex tw-justify-between tw-flex-col md:tw-flex-row tw-gap-3"
                                                        [ngClass]="{
                                                            'md:tw-justify-between':
                                                                item?.fax ||
                                                                item?.email,
                                                            'md:tw-justify-start tw-gap-40':
                                                                !item?.fax &&
                                                                !item?.email
                                                        }"
                                                    >
                                                        <div
                                                            class="tw-flex tw-items-center"
                                                        >
                                                            <mat-icon
                                                                class="tw-text-sm tw-text-[#6D7A87]"
                                                            >
                                                                access_time
                                                            </mat-icon>
                                                            <div
                                                                class="tw-text-[#6D7A87] tw-text-sm"
                                                            >
                                                                {{ item.hours }}
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="tw-flex tw-items-center"
                                                        >
                                                            <mat-icon
                                                                class="tw-text-sm tw-text-[#6D7A87]"
                                                            >
                                                                phone
                                                            </mat-icon>
                                                            <div
                                                                class="tw-text-[#6D7A87] tw-text-sm"
                                                            >
                                                                {{ item.phone }}
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="tw-flex tw-items-center"
                                                            *ngIf="item.fax"
                                                        >
                                                            <mat-icon
                                                                class="tw-text-sm tw-text-[#6D7A87]"
                                                            >
                                                                fax
                                                            </mat-icon>
                                                            <div
                                                                class="tw-text-[#6D7A87] tw-text-sm"
                                                            >
                                                                {{ item.fax }}
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="tw-flex tw-items-center"
                                                            *ngIf="item.email"
                                                        >
                                                            <mat-icon
                                                                class="tw-text-sm tw-text-[#6D7A87]"
                                                            >
                                                                mail
                                                            </mat-icon>
                                                            <div
                                                                class="tw-text-[#6D7A87] tw-text-sm"
                                                            >
                                                                {{ item.email }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                    <ng-template #noSearchResult>
                                        <div
                                            class="tw-flex tw-justify-center tw-items-center tw-h-full tw-text-base tw-font-semibold tw-text-caption-gray"
                                        >
                                            {{
                                                "NEW_APPLICATION.NO_SEARCH_RESULT"
                                                    | translate
                                            }}
                                        </div>
                                    </ng-template>
                                </section>
                            </div>
                        </div>
                    </mat-expansion-panel>
                </div>
                <mat-divider
                    class="dividerDirector"
                    style="margin-bottom: 0 !important"
                ></mat-divider>
                <div
                    class="tw-flex tw-flex-wrap tw-gap-[10px] tw-items-center md:tw-rounded-[80px] tw-py-[20px] tw-px-[0] md:tw-px-[15px] lg:tw-px-[27px]"
                >
                    <div
                        class="tw-order-2 md:tw-order-1 tw-flex-[0_0_100%] md:tw-flex-[0_0_calc(50%_-_10px)]"
                    >
                    </div>
                    <div
                        class="tw-order-1 md:tw-order-2 md:tw-text-right tw-flex-[0_0_100%] md:tw-flex-[0_0_50%] tw-mb-[18px] md:tw-mb-0"
                    >
                        <button
                            [attr.ga-event-id]="prodCode + '_next_button_cep_click'"
                            ga-event-category="Check Eligibilty Page Button"
                            [attr.ga-event-label]="prodCode + ' Next Eligibilty Button'"
                            ga-track="track"
                            (click)="onSubmit()"
                            class="tw-text-[18px] tw-leading-[20px] md:tw-max-w-[175px] tw-w-full tw-text-center tw-font-[600] tw-rounded-[32px] tw-text-white tw-py-[22px] tw-px-[15px]"
                            [ngClass]="
                                disableSubmitBtn
                                    ? 'tw-bg-slate-300'
                                    : 'tw-bg-gradient-to-r tw-from-orange-400 tw-to-amber-300'
                            "
                        >
                            {{ "NEXT" | translate }}
                        </button>
                    </div>
                </div>
            </div>
            <!-- implement eligible component here -->
        </div>
    </div>
</section>

<!-- footer component-->
<app-footer></app-footer>
